import InputField from "../../InputField/InputField";
import { HeadingTitle } from "../ModalContainer";
import { toast } from "react-toastify";
import { useState } from "react";
import axios from "axios";
import Loader from "../../Loading/Loading";
import { BASEURI } from "../../../Middleware/axiosInstance";
import secureLocalStorage from "react-secure-storage";

const AddCutName = ({ title, close, product_group_id, fetchData }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (name === "") {
        toast.error("Please enter the cut name.");
        return;
      }
      const { data } = await axios.post(`${BASEURI}`, {
        service_name: "manufacture_cut_name_save",
        token: token,
        product_group_id: product_group_id,
        name: name,
        is_missing: 0,
      });

      if (data.status === 1) {
        toast.success("Submitted Successfully");
        fetchData();
      } else {
        toast.error(data?.msg);
      }
      setLoading(false);
      close();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div>
      <HeadingTitle title={title} center={false} closeModal={close} />
      <div className="mtx-3">
        <div>
          <InputField
            label={"Cut Name"}
            placeholder={"Enter cut name"}
            onChange={(value) => setName(value)}
          />
        </div>
      </div>
      <div className="mt-3 text-center">
        <button
          className="add-btn"
          onClick={handleSubmit}
          style={{ backgroundColor: "#3C94C6" }}
        >
          {loading ? <Loader color={"#ffffff"} size={18} /> : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default AddCutName;
